
import {
  NonExtendedConditionObjectType,
  IStringConditionObject,
  INumericConditionObject,
} from 'src/Types/UrvalTypes';
import { ConditionValues } from './ConditionValues/ConditionValues';
import EDGrid from '../../../../../BaseComponents/GridComponents/EDGrid';
import ConditionLabel from './ConditionLabel';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import {
  CondOperatorType,
  ExtendedOperatorType,
} from '../../../../../Types/ClientModelTypes';
import classNames from 'classnames';
import { setValueConditionOperator } from '../Utils/UrvalValueConditionObjectUtils';
import { URVAL_INDENT } from '../../../Consts/UrvalConsts';
import ConditionMenu from './ConditionMenu/ConditionMenu';
import { tail } from 'ramda';
import { useIsSmallScreen } from '../../../../../Hooks/useFullscreenView';

interface IProps {
  conditionObject: NonExtendedConditionObjectType;
  setConditionObject: (
    newConditionObject: NonExtendedConditionObjectType
  ) => void;
  deleteConditionObject: () => void;
  indention: number;
  // width: Breakpoint;
  disabled: boolean;
  classes?: any;
}

const styles = (theme: Theme) => ({
  notValueCondition: {
    marginTop: '12px',
  },
  indented: {
    marginLeft: theme.spacing(3),
  },
  item: {},
  conditionLabel: {},
  conditionOperator: {
    [theme.breakpoints.up('sm')]: {
      marginTop: '8px',
    },
  },
  conditionValues: {
    [theme.breakpoints.up('sm')]: {
      marginTop: '8px',
    },
  },
});

const NonExtendedCondition: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const setConditionOperator =
    (conditionObject: IStringConditionObject | INumericConditionObject) =>
    (newConditionOperator: CondOperatorType) => {
      const { setConditionObject } = props;
      const newConditionObject = setValueConditionOperator(
        0,
        newConditionOperator,
        conditionObject
      );
      setConditionObject(newConditionObject);
    };

  const {
    conditionObject,
    deleteConditionObject,
    setConditionObject,
    classes,
    indention,
    disabled,
  } = props;
  const { attribute } = conditionObject;

  const isNotValueCondition =
    conditionObject.type !== 'String' && conditionObject.type !== 'Numeric';

  const isSmallScreen = useIsSmallScreen();

  // FIXME: Varför indenteras Griden utanför skärmen på små skärmar?
  return (
    <EDGrid
      data-testid="nonExtendedCondition"
      container
      spacing={0}
      className={classNames({
        [classes.notValueCondition]: isNotValueCondition,
      })}
      style={isSmallScreen ? { paddingLeft: URVAL_INDENT * indention } : {}}
    >
      <EDGrid item xs={12} sm={3} md={3} className={classes.conditionLabel}>
        <div>
          <ConditionLabel
            indention={isSmallScreen ? 0 : indention}
            displayLabel={attribute.DisplayLabel}
            conditionObject={conditionObject}
            deleteConditionObject={deleteConditionObject}
            disabled={disabled}
          />
          {(conditionObject.type === 'Numeric' ||
            conditionObject.type === 'String') &&
            tail(conditionObject.condition[0].values).map(value => (
              <ConditionLabel
                key={value.id}
                indention={isSmallScreen ? 0 : indention}
                displayLabel={'-Eller'}
                conditionObject={conditionObject}
                deleteConditionObject={deleteConditionObject}
                disabled={disabled}
              />
            ))}
        </div>
      </EDGrid>
      {(conditionObject.type === 'String' ||
        conditionObject.type === 'Numeric') && (
        <>
          <EDGrid
            item
            xs={11}
            sm={7}
            md={7}
            lg={8}
            className={classes.conditionValues}
          >
            <ConditionValues
              conditionObject={conditionObject}
              deleteConditionObject={deleteConditionObject}
              setConditionObject={setConditionObject}
              disabled={disabled}
            />
          </EDGrid>
          <EDGrid item xs={1} className={classes.conditionOperator}>
            <ConditionMenu
              availableConditionOperatorKeys={
                conditionObject.attribute.CondOperators ?? []
              }
              setConditionOperator={
                setConditionOperator(conditionObject) as (
                  newConditionOperator: CondOperatorType | ExtendedOperatorType
                ) => void
              }
              disabled={disabled}
              conditionObject={conditionObject}
            />
          </EDGrid>
        </>
      )}
      {conditionObject.type !== 'String' &&
        conditionObject.type !== 'Numeric' && (
          <EDGrid
            item
            xs={11}
            sm={7}
            md={7}
            lg={8}
            className={classes.conditionValues}
          >
            <ConditionValues
              conditionObject={conditionObject}
              deleteConditionObject={deleteConditionObject}
              setConditionObject={setConditionObject}
              disabled={disabled}
            />
          </EDGrid>
        )}
    </EDGrid>
  );
};

export default withStyles(NonExtendedCondition, styles);
